import React from 'react';

// @ts-expect-error - no type delcaration exists for this package
import { Generic, GenericCollection, JSONLD, Question } from 'react-structured-data';

import modularBlockShape from 'shapes/modularBlockShape';

import { getRawText } from 'utils/functions';

ModularSchema.propTypes = {
  modularBlocks: modularBlockShape,
};

interface ModularSchemaProps {
  modularBlocks: any[];
}

function ModularSchema({ modularBlocks }: ModularSchemaProps) {
  const faqs =
    (modularBlocks &&
      modularBlocks
        .filter((block) => block?.basicTextBlock && block?.basicTextBlock?.accordion)
        .map((block) => ({ ...block?.basicTextBlock }))) ??
    [];

  return (
    <>
      {/* SEO Structured Data - FAQ */}
      {faqs.length > 0 && (
        <JSONLD dangerouslyExposeHtml>
          <Generic type='faqPage' jsonldtype='FAQPage'>
            <GenericCollection type='mainEntity'>
              {faqs.map((faq, index) => (
                <Question name={getRawText(faq.header)} key={index}>
                  <Generic jsonldtype='Answer' type='acceptedAnswer' schema={{ text: getRawText(faq.body) }} />
                </Question>
              ))}
            </GenericCollection>
          </Generic>
        </JSONLD>
      )}
    </>
  );
}

export default React.memo(ModularSchema);
